module.exports = __webpack_public_path__ + "img/solit-cafe.c0917f7e.png";